var map = {
	"./aha.svg": "f7bf",
	"./begin.svg": "48d3",
	"./close.svg": "7710",
	"./finger.svg": "7bed",
	"./green-flag.svg": "1b78",
	"./ide-action.svg": "3beb",
	"./ide-aha.svg": "75ff",
	"./ide-console.svg": "dece",
	"./ide-data.svg": "2650",
	"./ide-event.svg": "c376",
	"./ide-func.svg": "2e56",
	"./ide-geometric.svg": "06fa",
	"./ide-judge.svg": "f8936",
	"./ide-kit.svg": "20ae",
	"./ide-list.svg": "ec9c",
	"./ide-loop.svg": "fb3b",
	"./ide-math.svg": "5649",
	"./ide-physical.svg": "c30d",
	"./ide-probability.svg": "9c83",
	"./ide-property.svg": "4ab9",
	"./ide-scenes.svg": "af3b",
	"./ide-sprite.svg": "1946",
	"./ide-statistics.svg": "16ea",
	"./ide-turtle.svg": "c89d",
	"./ide-voice.svg": "e216",
	"./logo.svg": "bb69",
	"./phone.svg": "dd82",
	"./qq.svg": "1430",
	"./save.svg": "0e55",
	"./share.svg": "5306",
	"./wechat.svg": "80da",
	"./zoom_minus.svg": "d936",
	"./zoom_plus.svg": "a181"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";